import React from 'react';
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox"
import { green500, red500 } from "material-ui/styles/colors";
import Loading from 'layoutComponents/Loading';
import PropTypes from "prop-types";
import Compress from "react-image-file-resizer";
import { textUtils } from "../../utils/textUtils";

function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  const ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  const blob = new Blob([ab], {
    type: mimeString
  });
  return blob;
}

class DeliveryProofComponent extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  submit() {
    const { workOrderActions, orderId, orderCloseDetails, customerDetail } = this.props;

    const tempRequest = orderCloseDetails.getIn([
      "deliveryProofImageRequest"
    ]);

    const request = tempRequest.set('ecid', customerDetail.getIn(['ecid']));

    workOrderActions.deliveryProofSubmitStarted(request.toJS(), orderId);
  }

  onStateChange() {
    const { workOrderActions, orderCloseDetails, orderId } = this.props;

    const deliveryProofBypassFlag = orderCloseDetails.getIn([
      'closeOrderRequest',
      'deliveryProofAddMemoRequest',
      'deliveryProofBypassFlag'
    ]);

    workOrderActions.setDeliveryProofBypassFlag(!deliveryProofBypassFlag, orderId);
  }

  onTextChange(e) {
    const { workOrderActions, orderCloseDetails, orderId } = this.props;
    const description = orderCloseDetails.getIn([
      "deliveryProofImageRequest",
      "description"]);

    const request = {
      description: e.target.value.length > 256 ? description : e.target.value,
      validDescription: e.target.value.length >= 3
    };

    workOrderActions.setDeliveryProofDescription(request, orderId);
  }

  onChange(e) {
    const {
      workOrderActions,
      orderId,
    } = this.props;

    const file = e.target.files[0];
    const mimeType = file.type.split("/")[1];

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const imageUncompressed = dataURItoBlob(reader.result);

      Compress.imageFileResizer(
        imageUncompressed, // the file from input
        480, // width
        480, // height
        "JPEG", // compress format WEBP, JPEG, PNG
        70, // quality
        0, // rotation
        (uri) => {
          workOrderActions.setDeliveryProofImage(
            {
              image: uri,
              mimeType: mimeType,
            }, orderId);
        },
        "base64" // blob or base64 default base64
      );
    };
  }

  handleClick(e) {
    this.imageRef.click();
  }

  render() {
    const { orderCloseDetails } = this.props;

    const image = orderCloseDetails.getIn([
      "deliveryProofImageRequest",
      "imageBase64"]);

    const description = orderCloseDetails.getIn([
      "deliveryProofImageRequest",
      "description"]);

    const deliveryProofSubmitSuccess = orderCloseDetails.getIn([
      "deliveryProofDetails",
      "deliveryProofSubmitSuccess"
    ]);

    const message = orderCloseDetails.getIn([
      "deliveryProofDetails",
      "message"
    ]);

    const validDescription = orderCloseDetails.getIn([
      "deliveryProofDetails",
      "validDescription"
    ]);

    const deliveryProofBypassFlag = orderCloseDetails.getIn([
      'closeOrderRequest',
      'deliveryProofAddMemoRequest',
      'deliveryProofBypassFlag'
    ]);

    const loading = orderCloseDetails.getIn([
      "deliveryProofDetails",
      "loading"
    ]);


    const displayMessageBlock = !loading && message ? (<div className="row">
      <div className="col s12">
        <h5 style={{ color: deliveryProofSubmitSuccess ? green500 : red500, padding: "5%" }}>
          {message}
        </h5>
      </div>
    </div>) : null;

    return (<div style={{ marginTop: "24px" }}>
      <Loading
        isLoading={!!loading}
      />
      <div>
        {image ?
          <img alt="" className="wow-delivery-proof-image" src={image} />
          : null
        }
        <div className="row">
          <div className="col s12">
            <Checkbox
              label={textUtils.workOrder.deliveryProofCheckbox}
              checked={!!deliveryProofBypassFlag}
              onCheck={this.onStateChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <RaisedButton
              disabled={deliveryProofSubmitSuccess}
              label="Attach delivery proof"
              fullWidth
              primary={true}
              onTouchTap={this.handleClick}
            />
            <input
              id={"deliveryProofUploader"}
              onChange={this.onChange}
              type="file"
              accept="image/*"
              ref={ref => this.imageRef = ref}
              style={{ display: 'none' }}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          <TextField
            fullWidth
            floatingLabelText="Where did you leave the kit?"
            onChange={this.onTextChange}
            multiLine={true}
            value={description}
          />
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          <RaisedButton
            disabled={!validDescription || !image || deliveryProofSubmitSuccess}
            label="Submit"
            fullWidth
            primary={true}
            onTouchTap={this.submit}
          />
        </div>
        {
          displayMessageBlock
        }
      </div>
    </div>
    );
  }
}

DeliveryProofComponent.propTypes = {
  workOrderActions: PropTypes.object,
  orderCloseDetails: PropTypes.object,
  customerDetail: PropTypes.object,
  orderId: PropTypes.string,
};


export default DeliveryProofComponent;



// WEBPACK FOOTER //
// ./src/components/delivery-proof/DeliveryProofComponent.js